import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/ui/CompanyProfileSlideshow.tsx");
